import { Skeleton } from '@frontend/components/ui/skeleton';

export function SearchEmptyLoading() {
  return (
    <div className="flex flex-col gap-2 mt-6">
      <Skeleton className="h-[52px] rounded-lg" />
      <Skeleton className="h-[52px] rounded-lg" />
      <Skeleton className="h-[52px] rounded-lg" />
      <Skeleton className="h-[52px] w-[90%] rounded-lg" />
    </div>
  );
}
